<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'DRUG.DRUGS_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddDrug">
          <button
            (click)="createDrug()"
            mat-raised-button
            matTooltip="Create new drug"
            color="primary"
            type="button"
          >
            <span class="svg-icon-md" translate="DRUG.NEW_DRUG">
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              New Drug
            </span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 145px !important"
          class="btn btn-sm btn-light-{{ getItemCssClassByStatus(searchIsActiveSelect) }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(searchIsActiveSelect) }} Drugs
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="drug">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'DRUG.TABLE.DRUG' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let drug">
            <span
              [matTooltip]="canViewDrug(drug) ? 'View Drug' : null"
              [class.clickable]="canViewDrug(drug)"
              (click)="viewDrugDblclick(drug.id, drug)"
              >{{ getDrug(drug) }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDrug">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DRUG.TABLE.DRUG' | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'DRUG.TABLE.DRUG' | translate"
                [(ngModel)]="searchDrugInput"
              />
              <button
                *ngIf="searchDrugInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchDrugInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="form">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'DRUG.TABLE.FORM' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let drug">{{ drug.form }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchForm">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DRUG.TABLE.FORM' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchFormInput"
                [placeholder]="'DRUG.TABLE.FORM' | translate"
              />
              <button
                *ngIf="searchFormInput"
                matSuffix
                mat-icon-button
                (click)="searchFormInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="ndc">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'DRUG.TABLE.NDC' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let drug">{{ drug.ndc }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchNDC">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DRUG.TABLE.NDC' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchNDCInput"
                [placeholder]="'DRUG.TABLE.NDC' | translate"
              />
              <button
                *ngIf="searchNDCInput"
                matSuffix
                mat-icon-button
                (click)="searchNDCInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="thClass">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'DRUG.TABLE.TH_CLASS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let drug">{{ drug.th_class }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchTHClass">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DRUG.TABLE.TH_CLASS' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchTHClassInput"
                [placeholder]="'DRUG.TABLE.TH_CLASS' | translate"
              />
              <button
                *ngIf="searchTHClassInput"
                matSuffix
                mat-icon-button
                (click)="searchTHClassInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="jcode">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'DRUG.TABLE.JCODE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let drug">{{ drug.jcode }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchJCode">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DRUG.TABLE.JCODE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchJCodeInput"
                [placeholder]="'DRUG.TABLE.JCODE' | translate"
              />
              <button
                *ngIf="searchJCodeInput"
                matSuffix
                mat-icon-button
                (click)="searchJCodeInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'DRUG.TABLE.STATUS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let drug">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(drug.is_active?.toString())
              }} label-inline text-center"
            >
              {{ getItemStatusString(drug.is_active?.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DRUG.TABLE.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'DRUG.TABLE.STATUS' | translate"
                (selectionChange)="handleStatusChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let drug">
            <ng-template ngxPermissionsOnly="canViewDrug">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Drug"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewDrug(drug)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditDrug">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Drug"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editDrug(drug.id)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivateDrug">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Drug"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateStatusForDrug(drug)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteDrug">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Drug"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteDrug(drug)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>

